






















import { Vue, Component } from 'vue-property-decorator';
import DashboardOs from '@/pantallas/Dashboard/DashboardOs.vue';
import DashboardTs from '@/pantallas/Dashboard/DashboardTs.vue';
import DashboardKi from '@/pantallas/Dashboard/DashboardKi.vue';

@Component({
  components: { DashboardOs, DashboardTs, DashboardKi },
})
export default class DispositivoPantalla extends Vue {
  tabSelected: number = 0;
  loadGraphTransmission: boolean = false;
  loadGraphOperation: boolean = false;
  notifyLoadOp: boolean = true;

  selectTransmission() {
    this.tabSelected = 1;
    this.loadGraphTransmission = true;
    this.loadGraphOperation = false;
  }
  selectOperation() {
    this.tabSelected = 0;
    this.loadGraphTransmission = false;
    this.loadGraphOperation = true;
  }
  selectKilometer() {
    this.tabSelected = 2;
    this.loadGraphTransmission = false;
    this.loadGraphOperation = false;
  }
  notifyLoadOperation(value: boolean) {
    this.notifyLoadOp = value;
  }
}
